/**
 * Strip HTML tags from a string and return plain text
 * Uses DOMParser to safely parse HTML without executing scripts
 * @param html - String that may contain HTML tags
 * @returns Plain text without HTML tags
 */
export const stripHtml = (html) => {
    // Use DOMParser to safely parse HTML without XSS risk
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // Get the text content (this automatically strips all HTML tags)
    return doc.body.textContent || '';
};
